import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
function isWindow(node) {
  return node === window;
}
function isElement(element) {
  return element instanceof Element;
}
function getScrollParent(node) {
  if (!node || isWindow(node)) {
    return null;
  }
  var overflowX = window.getComputedStyle(node).overflowX;
  var overflowY = window.getComputedStyle(node).overflowY;
  var isScrollable = !(overflowX.includes('hidden') || overflowY.includes('hidden') || overflowX.includes('visible') || overflowY.includes('visible'));
  if (isScrollable && (node.scrollHeight >= node.clientHeight || node.scrollWidth >= node.clientWidth)) {
    return node;
  }
  if (isElement(node.parentNode)) {
    return getScrollParent(node.parentNode);
  }
  return document.scrollingElement || document.body;
}
export default getScrollParent;